export const environment = {
    production: false,
    apiUrl: "https://test.larry-jacobo.com/api",
    apiPythonUrl: "https://test.larry-jacobo.com/py"
};